module.exports = [{
      plugin: require('../../../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Beispiel | Eintracht Frankfurt","short_name":"Beispiel | Eintracht Frankfurt","lang":"de","start_url":"/","background_color":"#ffffff","theme_color":"#ffffff","display":"minimal-ui","icon":"favicon/gatsby-ef-favicon.svg"},
    },{
      plugin: require('../../../themes/gatsby-theme-ef-base/gatsby-browser.js'),
      options: {"plugins":[],"website":"beispiel","website_title":"Beispiel","website_theme":"light","website_background_color":"#ffffff","website_lang":"de","filter":["global"]},
    }]
